export const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

export const endPoints = {
  signupRestaurant: "register",
  loginAdmin: "loginAdmin",
  addProduct: "addProduct",
  allProducts: "getProduct",
  editProduct: "updateProduct",
  deleteProduct: "deleteProduct",
  addCategory: "createCategory",
  editCategory: "updateCategory",
  deleteCategory: "deleteCategory",
  updateRequestedCategory: "updateRequestedCategory",
  updateRequestedCategoryReject: "updateRequestedCategoryRejected",
  getCategories: "getCategory",
  getPromotions: "getAllPromo",
  addPromotion: "createPromo",
  editPromotion: "updatePromo",
  deletePromotion: "deletePromo",
  getResturantProfile: "getRestaurantProfile",
  editResturantProfile: "updateRestaurantProfile",
  updateRestaurantStatus: "updateRestaurantStatus",
  changeRestaurantPassword: "changePassword",
  getCategoryByAdmin: "getCategoryByAdmin",
  getAllRestaurants: "getAllRestaurants",
  updateDeliveryCharges: "updateDeliveryCharges",
  changePassword: "changePassword",
  getAdminDetails: "getAdminDetails",
  getOrderbyRest: "getOrder",
  restOrderStatusUpdate: "updateOrderStatus",
  getAllPromotionsByAdmin: "getAllPromo",
  forgotRestCode: "forgotRestCode",
  resetRestPassword: "resetRestPassword",
  restDashboard: "RestDashboard",
  adminDashboard: "getDashboardDeatils",
  allText: "getAllMessages",
  updateAllText: "updateMessage",
  getAllUsers : "getAllUsers",
  updateUserStatus : "updateUserStatus",

  changePasswordAdmin:"changePasswordAdmin",
  updateAdminProfile:"updateAdminProfile",
  getComplaints : "getComplains",
  getAllMatches:"getAllMatches",
};
